import { EmptyMenu } from '../img/icons/EmptyMenu';

const MenuUnavailable = () => {
  return (
    <div className="menu-widget-catering-menu__empty-card">
      <EmptyMenu />

      <div className="menu-widget-catering-menu__empty-card-text">
        Menu nie jest dostępne
      </div>
    </div>
  );
};

export default MenuUnavailable;
